module.exports = __webpack_public_path__ + "img/ffsinvate-pc.f037eb2.png";